import { isScm, isCustomer, isCustomerAdmin, isCustomerUser, isCluster, isSuperVisor, isSp, isPsp, isIsp, isFe, isSpIsp, isFM, isCustomerGroup, isBranchUser } from '../../utils/role';

import { getPaymentsMainTabs } from '../../pages/Payments/PaymentController';
import { ticket, inventory, projects, payments, teamWork, chats, wallet, customerBilling, collab, ModulesPathKey } from '../../router/roleWisePageRoute';
import { isToShowCustomerBillingTab } from '../../utils/access';

const projectsSidebarTab = {
    key: ModulesPathKey.project,
    name: 'Projects',
    imgSrc: '/img/projects.svg',
    Linkto: projects.path,
};

const ticketSidebarTab = {
    key: ModulesPathKey.ticket,
    name: 'Ticket',
    imgSrc: '/img/ticket.svg',
    Linkto: ticket.path,
};

const inventorySidebarTab = {
    key: ModulesPathKey.inventory,
    name: 'Inventory',
    imgSrc: '/img/sites.svg',
    Linkto: inventory.path,
};

const teamSidebarTab = {
    key: ModulesPathKey.team,
    name: 'Team',
    imgSrc: '/img/groups.svg',
    Linkto: teamWork.path,
};

export const chatSidebarTab = {
    key: ModulesPathKey.chat,
    name: 'Chats',
    imgSrc: '/img/sidebar_chat.png',
    Linkto: chats.path,
    countKey: 'chatNotificationCount',
};

export const paymentsSidebarTab = {
    key: ModulesPathKey.payment,
    name: (role, type, frontend_controller, manage_partner_payments) => {
        if (manage_partner_payments === 1 && isCustomerGroup(role, type)) {
            return 'Payments';
        }
        if (isCustomer(role, type) || isCustomerAdmin(role, type) || isCustomerUser(role, type) || isIsp(role, type)) {
            return 'Finance';
        }
        return 'Payments';
    },
    imgSrc: '/img/payments_scogo.svg',
    Linkto: payments.path,
};

const walletSidebarTab = {
    key: ModulesPathKey.wallet,
    name: 'Wallet',
    imgSrc: '/img/payments.svg',
    Linkto: wallet.path,
};

const customerBillingSidebarTab = {
    key: ModulesPathKey.customer_billing,
    name: 'Customer Billing',
    imgSrc: '/img/customer_billing.svg',
    Linkto: customerBilling.path,
};


export const dashboardTab = {
    key: ModulesPathKey.dashboard,
    name: 'Dashboard',
    imgSrc: '/img/dashboard.svg',
    Linkto: '/dashboard',
};

export const getSidebar = (sidebarList, { grafana_dashboard_url, org_id } = {}) => {
    if (!sidebarList || sidebarList?.length === 0) return [];
    let tabs = [projectsSidebarTab, ticketSidebarTab, teamSidebarTab, inventorySidebarTab, paymentsSidebarTab, walletSidebarTab, chatSidebarTab, customerBillingSidebarTab];
    let filteredtabs = tabs.filter((tab) => {
        const find = sidebarList.find(({ key }) => key === tab.key);
        if (find) {
            tab.name = find.label;
            return tab;
        }
        return false;
    });

    if (org_id === 'org_2wjcB9HGJSLRNuLeIyyciKE3VHO') {
        const paymentTabIndex = filteredtabs.findIndex(tab => tab.key === ModulesPathKey.payment);
        if (paymentTabIndex > -1) {
            const paymentTab = filteredtabs.splice(paymentTabIndex, 1)[0];
            filteredtabs.unshift(paymentTab);
        }
    }

    if (grafana_dashboard_url) filteredtabs = [dashboardTab, ...filteredtabs]

    return filteredtabs;
};
